export default {"src":"/_next/static/media/MPC.2d4db9ce.svg","height":18,"width":18};